import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { BuyGetStatus } from "../../../../types/product/ibrief-product/buy-get-status.enum";

import { WorkOrderProductsFormContext } from "./work-order-products.interface";

function productIsAssigned(context: () => WorkOrderProductsFormContext, id: number) {
  return (
    !context().metaData.isBuyGet ||
    context().currentValues.products.some((product) => product.relatedGetProductIds.includes(id))
  );
}

function statusIsBuy(context: () => WorkOrderProductsFormContext, buyGetStatus: BuyGetStatus) {
  return context().metaData.isBuyGet && buyGetStatus === BuyGetStatus.Buy;
}

export const productsValidation = yupResolver(
  yup.object({
    products: yup.array().of(
      yup.object({
        buyGetStatus: yup.number().when(["$getContext", "id"], {
          is: productIsAssigned,
          then: (schema) => schema,
          otherwise: (schema) =>
            // Cannot be Get is not assigned
            schema.notOneOf([BuyGetStatus.Get], "Get Product {X} is not assigned."),
        }),

        relatedGetProductIds: yup
          .array()
          .of(yup.number())
          .when(["$getContext", "buyGetStatus"], {
            is: statusIsBuy,
            then: (schema) =>
              schema.min(
                1,
                "Product {X} is a Buy product must have at least one assigned Get product."
              ),
            otherwise: (schema) => schema,
          }),
      })
    ),
  })
);
